import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

export const SquaresIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 22 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8 12C9.10457 12 10 12.8954 10 14V20C10 21.0357 9.21278 21.887 8.2041 21.9893L8 22H2L1.7959 21.9893C0.854346 21.8938 0.1062 21.1457 0.0107422 20.2041L0 20V14C0 12.8954 0.895431 12 2 12H8ZM20 12C21.1046 12 22 12.8954 22 14V20C22 21.0357 21.2128 21.887 20.2041 21.9893L20 22H14L13.7959 21.9893C12.8543 21.8938 12.1062 21.1457 12.0107 20.2041L12 20V14C12 12.8954 12.8954 12 14 12H20ZM2 20H8V14H2V20ZM14 20H20V14H14V20ZM8 0C9.10457 0 10 0.895431 10 2V8C10 9.03565 9.21278 9.887 8.2041 9.98926L8 10H2L1.7959 9.98926C0.854346 9.8938 0.1062 9.14565 0.0107422 8.2041L0 8V2C0 0.895431 0.895431 1.61064e-08 2 0H8ZM20 0C21.1046 0 22 0.895431 22 2V8C22 9.03565 21.2128 9.887 20.2041 9.98926L20 10H14L13.7959 9.98926C12.8543 9.8938 12.1062 9.14565 12.0107 8.2041L12 8V2C12 0.895431 12.8954 1.61064e-08 14 0H20ZM2 8H8V2H2V8ZM14 8H20V2H14V8Z'
        fill={color}
      />
    </svg>
  )
})
